import '../../../prop-types/add-on.types';

/**
 * Returns a boolean indicating if the add-on is eligible to be trialed.
 * @param {AddOnPropType} feature
 * @returns {boolean} a boolean indicating if the add-on is available for trial.
 */
export const isAddOnAvailableForTrial = (feature) => {
  const canBeTrialed = feature.canTrial;
  const isAvailable = !feature.isActive;
  return canBeTrialed && isAvailable;
};
